import { createRequest } from "helpers/tools";

export const deleteDomainsAsyns = async (id) => {
    return await createRequest({
        suffix: `sources/allowed-domains/${id}`,
        method: "delete",
        handleError: false,
    });
};
